var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMentalHealthLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C12.068 0 15.426 3.036 15.934 6.965L18.184 10.504C18.332 10.737 18.302 11.084 17.959 11.232L16 12.07V15C16 16.105 15.105 17 14 17H12.001L12 20H3V16.306C3 15.126 2.564 14.009 1.756 13.001C0.657 11.631 0 9.892 0 8C0 3.582 3.582 0 8 0ZM8 2C4.686 2 2 4.686 2 8C2 9.385 2.468 10.693 3.316 11.75C4.41 13.114 5 14.667 5 16.306V18H10L10.002 15H14V10.752L15.55 10.088L14.007 7.663L13.95 7.221C13.566 4.251 11.024 2 8 2ZM7.47 5.763L8 6.293L8.53 5.763C9.214 5.079 10.322 5.079 11.005 5.763C11.689 6.446 11.689 7.554 11.005 8.237L8 11.243L4.995 8.237C4.311 7.554 4.311 6.446 4.995 5.763C5.678 5.079 6.786 5.079 7.47 5.763Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentalHealthLine);
export default __webpack_public_path__ + "static/media/mental-health-line.39969d4e1b980462e53080f421f9f961.svg";
export { ForwardRef as ReactComponent };